import { useAuth } from 'context/auth'
import ClickOutSide from 'hooks/click-outside'
import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { useOperator } from 'context/operator'

import { Copy, Check, Info } from 'lucide-react'

function ProfileButton() {
  const { currentUser, logout } = useAuth()
  const [openProfile, setOpenProfile] = useState(false)
  const [copied, setCopied] = useState(false)
  const {operator} = useOperator()

  const handleCopy = () => {
    if (operator?._id) {
      navigator.clipboard.writeText(operator._id)
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    }
  }

  return (
    <div className="relative">
      <button
        type="button"
        className="
          flex text-sm rounded-full
          focus:outline-none focus:ring-2 focus:ring-[#BA141B]/50 focus:ring-offset-2
          transition-all duration-150
        "
        onClick={() => setOpenProfile(!openProfile)}
      >
        <span className="sr-only">Open user menu</span>
        <img
          className="
            w-9 h-9 object-cover rounded-full
            border-2 border-[#BA141B]/30 bg-white
            shadow-sm
          "
          src={currentUser.avatar || 'https://placehold.co/600x600?text=User'}
          alt="User avatar"
        />
      </button>

      <ClickOutSide onClickOutside={() => setOpenProfile(false)}>
        {openProfile && (
          <div
            className="
              z-50 mt-2 absolute right-0 top-full
              w-64 min-w-[240px]
              bg-white rounded-xl shadow-xl border border-gray-200
              divide-y divide-gray-100 overflow-hidden
            "
          >
            {/* User info */}
            <div className="px-5 py-4">
              <p className="text-base font-semibold text-[#BA141B] truncate">
                {currentUser.fullname || 'User'}
              </p>
              <p className="text-sm text-gray-600 truncate mt-0.5">
                {currentUser.email}
              </p>
              <div className='mt-3 pt-3 border-t border-gray-100'>
                <div className='flex-col items-center justify-between gap-2 text-[12px] text-gray-500 bg-gray-50 px-2 py-1.5 rounded border border-gray-100'>
                  <span className='font-medium uppercase tracking-wider'>Business ID</span>
                  <div className='flex items-center gap-1.5'>
                    <code className='font-mono text-gray-400'>{operator?._id}</code>
                    <button
                      onClick={handleCopy}
                      className='p-1 hover:bg-gray-200 rounded transition-colors'
                      title='Copy Business ID'
                    >
                      {copied ? (
                        <Check className='w-3 h-3 text-green-600' />
                      ) : (
                        <Copy className='w-3 h-3 text-gray-400' />
                      )}
                    </button>
                    
                    <div className='group/info relative flex items-center'>
                      <Info className='w-3 h-3 text-gray-400 cursor-help hover:text-[#BA141B] transition-colors' />
                      <div className='absolute right-0 bottom-full mb-2 w-48 p-2 bg-gray-900 text-white text-[10px] leading-tight rounded-lg opacity-0 invisible group-hover/info:opacity-100 group-hover/info:visible transition-all z-50 pointer-events-none shadow-xl font-normal text-center'>
                        Provide this to your customer to use on signup
                        <div className='absolute right-2 top-full w-0 h-0 border-8 border-transparent border-t-gray-900'></div>
                      </div>
                    </div>
                  </div>
                </div>
                {copied && (
                  <p className='text-[10px] text-green-600 font-medium text-right mt-1 animate-pulse'>
                    Copied to clipboard!
                  </p>
                )}
              </div>
            </div>

            {/* Menu */}
            <ul className="py-2 text-sm text-gray-700">
              <li>
                <Link
                  to="/profile"
                  className="
                    block px-5 py-2.5
                    hover:bg-[#F5821F]/5 hover:text-[#F5821F]
                    transition-colors duration-150
                  "
                  onClick={() => setOpenProfile(false)}
                >
                  Profile
                </Link>
              </li>

              <li>
                <button
                  type="button"
                  onClick={() => {
                    logout()
                    setOpenProfile(false)
                  }}
                  className="
                    w-full text-left px-5 py-2.5
                    hover:bg-red-50 hover:text-red-700
                    transition-colors duration-150
                  "
                >
                  Sign out
                </button>
              </li>
            </ul>
          </div>
        )}
      </ClickOutSide>
    </div>
  )
}

export default ProfileButton